const BASE_URL = 'https://techsolutionsservice.ustdev.com/supplier/reporting/presurvey';

// Fetch presurvey data for a given supplier ID
export async function fetchPresurveyData(supplierId) {
  
  
  try {
    const response = await fetch(`${BASE_URL}/${supplierId}`,{headers:{
      Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
    }});
   
    
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
   
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching presurvey data:', error);
    throw error;
  }
}

// Fetch pillar data
export async function fetchPillarData() {
  try {
    const response = await fetch(`${BASE_URL}/config`,{headers:{
      Authorization:`Bearer ${sessionStorage.getItem("authToken")}`
    }});
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching pillar data:', error);
    throw error;
  }
}

// Helper function to format date in YYYYMMDD format
function formatDateYYYYMMDD(dateString) {
  if (!dateString) return null;
  
  // Parse DD-MM-YYYY format
  const [day, month, year] = dateString.split('-');
  
  // Create date in YYYY-MM-DD format that JavaScript can parse
  const formattedDate = `${year}-${month}-${day}`;
  
  const d = new Date(formattedDate);
  const formattedYear = d.getFullYear();
  const formattedMonth = String(d.getMonth() + 1).padStart(2, '0');
  const formattedDay = String(d.getDate()).padStart(2, '0');
  
  return `${formattedYear}-${formattedMonth}-${formattedDay}`;
}

export async function savePresurveyData(supplierId, data) {
  try {
    // Transform the data to match the new format
    const transformedData = {
      supplierId: supplierId || "9839", // Default or provided supplier ID
      supplierName: data.supplierName || "GreenTech Innovations",
      reportCreationYear: data.reportCreationYear || 2024,
      periodStartDate: formatDateYYYYMMDD(data.periodStartDate),
      periodEndDate: formatDateYYYYMMDD(data.periodEndDate),
      cdpDataAvailable: data.cdpDataAvailable || false,
      otherDataToReport: data.otherDataToReport || false,
      focusAreas: {
        sustainability: data.focusAreas?.sustainability || true,
        carbonEmissions: data.focusAreas?.carbonEmissions || true,
        waterManagement: data.focusAreas?.waterManagement || false,
        socialResponsibility: data.focusAreas?.socialResponsibility || true,
        Energy: data.focusAreas?.Energy || false,
        Waste: data.focusAreas?.Waste || false,
        Packaging: data.focusAreas?.Packaging || false
      },
      createdDate: new Date().toISOString(),
      createdUser: "admin_user",
      updatedDate: new Date().toISOString(),
      updatedUser: "system_update"
    };
    
    const response = await fetch(BASE_URL, {
      method: 'POST',
      headers: {
        Authorization:`Bearer ${sessionStorage.getItem ("authToken")}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(transformedData),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error saving presurvey data:', error);
    throw error;
  }
}